import ProjectTitle from './ProjectTitle';

export default ProjectTitle;
